/**
 * Utility to determine whether the browser supports window popups.
 * Heavily influenced by https://www.paypalobjects.com/api/checkout.js
 */
var isIos = function isIos(ua) {
  return /iPhone|iPod|iPad/.test(ua);
};

var isOperaMini = function isOperaMini(ua) {
  return /Opera Mini/i.test(ua);
};

var isAndroid = function isAndroid(ua) {
  return /Android/.test(ua);
};

var isIosWebviewOrGoogleSearchApp = function isIosWebviewOrGoogleSearchApp(ua) {
  var googleSearchAppRegex = /\bGSA\b/;
  var appleWebViewRegex = /.+AppleWebKit(?!.*Safari)|.*WKWebView/;
  return isIos(ua) && (googleSearchAppRegex.test(ua) || appleWebViewRegex.test(ua));
};

var isAndroidWebview = function isAndroidWebview(ua) {
  return isAndroid(ua) && !isOperaMini(ua) && /Version\/[\d.]+/.test(ua);
};

var isFirefoxIos = function isFirefoxIos(ua) {
  return /FxiOS/i.test(ua);
};

var isEdgeIos = function isEdgeIos(ua) {
  return /EdgiOS/i.test(ua);
};

var isFacebookWebView = function isFacebookWebView(ua) {
  return /FBAN/.test(ua) || /FBAV/.test(ua);
};

var isQQBrowser = function isQQBrowser(ua) {
  return /QQBrowser/.test(ua);
};

var isMacUIWebView = function isMacUIWebView(ua) {
  return /Macintosh.*AppleWebKit(?!.*Safari)/i.test(ua);
};

var isStandalone = function isStandalone() {
  return !!window.navigator.standalone || window.matchMedia('(display-mode: standalone)').matches;
};

export default function isPopupSupported(ua) {
  return !(isIosWebviewOrGoogleSearchApp(ua) || isAndroidWebview(ua) || isOperaMini(ua) || isFirefoxIos(ua) || isEdgeIos(ua) || isQQBrowser(ua) || isFacebookWebView(ua) || isMacUIWebView(ua) || isStandalone());
}
//# sourceMappingURL=isPopupSupported.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/fraud/~/@flowio/browser-helpers/dist/esm/isPopupSupported.js
// module id = 573
// module chunks = 0 1